import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastNotificationComponent } from '../shared/toast-notification/toast-notification.component';
import { ToastNotificationService } from './toast-notification/toast-notification.service';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root'
})
export class DisabledInvestmentCreationGuard  {
  public constructor(
    private userService: UserService,
    private toastService: ToastNotificationService,
  ) { }


  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.userService.loggedUser) {
      return false;
    }

    const enableInvestmentCreation = this.userService.loggedUser.validContracts.filter(contract => !contract.inLiquidation).length > 0;
    if (!enableInvestmentCreation) {
      this.toastService.addNotification({
        title: 'toastNotifications.headers.noAccess',
        message: 'toastNotifications.messages.noAccess',
        type: 'warning',
        component: ToastNotificationComponent,
      });
    }

    return enableInvestmentCreation;
  }
}
